import { init, getV1, getV2, postV1, putV1, putV2, delV1, getGFT } from '@/common/utils/ajax'
import { mapHouseItem, mapHouseDetail, mapHomePage, handleBanner, handleWxHeadimg } from '@/common/utils/map_view_data'

import LocalData from '@/utils/local_data'
import { App_User } from '../data/user_info';

import { DEFAULT_PER } from '@/config'

import check from '@/common/utils/check'
import { checkComment } from '@/common/utils/check_comment'

import { errorLog } from '@/utils/log'

import wx from '@/utils/wx'

const isProd = process.env.NODE_ENV === 'production'

const logging_in = (params) => {
    console.error('params', params)
    return postV1(`sessions/tft_oauth`, params)
}

const getSmsCaptcha = (mobile) => getGFT('v1/sms_captcha', { mobile })

const getBuildings = (options) => getV1('buildings', {
    per: DEFAULT_PER,
    ...options
}).then(data => {
    if (options.status === '摇号剩余') {
        data.items.forEach(item => {
            item.status = '在售'
        })
    }
    data.items = data.items.map(mapHouseItem)
    return data
})

const getHomePage = () => getV2('homepage')
    .then(mapHomePage)

const getBuilding = (id, house_id, consultant_group_id, status) => {
    const params = {}
    if (house_id) {
        params.house_id = house_id
    }
    if (consultant_group_id) {
        params.consultant_group_id = consultant_group_id
    }
    if (status) {
        params.status = status
    }
    return getV1(`buildings/${id}`, params)
        .then(mapHouseDetail)
}

const getHotHouses = () => getV1('hot_buildings')
    .then((data) => {
        data.items = data.items.map(mapHouseItem)
        data.hotpage_banner = handleBanner(data.hotpage_banner)
        return data
    })

const getBuildingComments = (id, options) => getV1(`buildings/${id}/comments`, options)

const getBuildingCommentDetail = (building_id, id) => getV1(`buildings/${building_id}/comments/${id}`)

const getCommentDetail = (id) => getV1(`comments/${id}`)

const getCommentsReply = (id, params) => {
    return getV1(`comments/${id}/child_comments`, params)
}

const newBuildingComment = (id, options = {}) => getV1(`buildings/${id}/comments/new`, options)

const postBuildingComment = async (id, options) => {
    if (options.content) {
        if (checkComment(options.content) ) {
            wx.showModal({
                title: '提示',
                content: '请勿发布手机号、微信号等违规内容',
                showCancel: false
            })
            return Promise.reject('violating_content')
        }
    }
    return postV1(`buildings/${id}/comments`, options)
        .then((data) => {
            if (data.code === 422) {
                wx.showToast({
                    title: data.error_message
                })
                return
            }
            return data
        })
}

const getCommunityTopics = (options) => getV1(`community_topics`, {
    per: DEFAULT_PER,
    ...options
})

const getCommunityTopicsDetail = (id) => getV1(`community_topics/${id}`)

const getTopicsComments = (options) => getV1(`comments`, {
    per: DEFAULT_PER,
    ...options
})

const postTopicsComment = async (options) => {
    return postV1(`comments`, options)
        .then((data) => {
            if (data.code === 422) {
                wx.showToast({
                    title: data.error_message
                })
                return
            }
            return data
        })
}

const getUserNums = id => getV1(`houses/${id}/user_ln_numbers`)

const addUserNum = (id, options) => postV1(`houses/${id}/user_ln_numbers`, options)
    .then((data) => {
        if (data.code === 422) {
            wx.showToast({
                title: data.error_message,
                icon: 'none'
            })
            return Promise.reject(data.error_message)
        }
        return data
    })

const getUserResult = (houseId, userId) => getV1(`houses/${houseId}/user_ln_numbers/${userId}`)

const getResult = (houseId, options) => getV1(`houses/${houseId}/ln_results`, options)

const getRegResult = (houseId, options) => getV1(`houses/${houseId}/ln_registers`, options)

const getLpdResult = (houseId, options) => getV1(`houses/${houseId}/lpd_results`, options)

const getLrdResult = (houseId, options) => getV1(`houses/${houseId}/lrd_results`, options)

const syncInfo = () => postV1('my_ln_houses')

const report = id => postV1('form_submits', {
    form_id: id
})

const getUserInfo = () => getV1('user')
    .then(user => {
        LocalData.user.set(user)
        return App_User.set(user)
    })

const getCustomerServiceStaff = () => getV1('customer_service_staff')

const getUserInfoByShareBy = (share_by, share_page = '') => {
    getV1('user', {
        share_by,
        share_page
    })
}

const updateUserInfo = data => putV1('user', data)

const getZones = () => getV2('zones')

const getUserPoints = () => getV1('user_point_journals')

const share = () => postV1('user_point_journals', { action_type: 'share' })

const getPointsStore = () => getV1('point_store')

const getComments = (id, options) => getV1(`houses/${id}/comments`, options)

const postComment = (id, options) => postV1(`houses/${id}/comments`, options)

const likeComment = (id) => postV1(`comments/${id}/like`)

const delLikedComment = (id) => delV1(`comments/${id}/like`)

const getChangeLog = (version) => getV1('change_log', { version })

const verifyQualication = (params, verify_type) => postV1('verify_qualification', {
    ...params,
    verify_type
})

const getLnDetail = (id, params) => {
    !params.ln_number && delete params.ln_number
    !params.register_number && delete params.register_number
    return getV1(`houses/${id}/ln_detail`, params)
}

const updateConsultant = (params) => {
    return putV2(`consultant`, params)
}

const getMyConsultant = () => {
    return getV2(`consultant`)
}

const editMyConsultant = () => {
    return getV2(`consultant/edit`)
}

const getConsultants = (params) => {
    return getV1(`consultant_cards`, params)
        .then(data => {
            data.score_top_3_consultants.forEach(item => handleWxHeadimg(item, 120))
            data.items.forEach(item => handleWxHeadimg(item, 144))
            return data
        }).catch(console.error)
}

const getConsultant = (id, params = {}) => {
    return getV1(`consultant_cards/${id}`, params)
        .then(data => {
            handleWxHeadimg(data, 144)
            return data
        })
}

const getConsultantHistory = (options) => {
    return getV1(`consultant_liveness_histories`, options)
}

const likeConsultant = (id, liked) => {
    if (liked) {
        return postV1(`consultants/${id}/like`)
    }
    return delV1(`consultants/${id}/like`)
}

const getConsultantViewers = (id, options) => {
    return getV1(`consultants/${id}/viewer_headimgs`, options)
}

const getConsultantScore = (id, data) => {
    return getV1(`consultants/${id}/score_journals`, data)
}

const getHouseNames = (options) => {
    return getV1('building_names', options)
}

const getWxArticles = (params) => {
    return getV1(`weixin_articles`, params)
}

const getMyFavourite = (params) => {
    return getV1(`followed_houses`, params)
        .then(data => {
            data.items = data.items
                .map(mapHouseItem)
            return data
        })
}

const addMyFavourite = (params) => {
    return postV1(`followed_houses`, params)
}

const delMyFavourite = (id) => {
    return delV1(`followed_houses/${id}`)
}

const addFollow = (params) => {
    return postV1(`follows`, params)
}

const delFollow = (params) => {
    return delV1(`follows/0`, params)
}

const getMsg = (params) => {
    return getV1('user_messages', params)
}

const readAllMsg = (tab_name) => {
    return postV1('user_messages/read_all', { tab_name })
}

const readAllTimMsg = () => {
    return postV1('tim_messages/read_all')
}

const readTimSession = (id) => postV1(`tim_sessions/${id}/read_all`)

const getNewMsgLen = () => getUserInfo()
    .then(({ unread_message_counts }) => {
        return {
            unread_message_counts
        }
    })
const viewTip = () => postV1('user/view_tip')

const createBlog = async (data) => {
    return postV1('blogs', data)
}

const getFeeds = (data) => getV1('feeds', data)

const getFeed = (id, share_by_consultant_uid = '') => getV1(`feeds/${id}`, { share_by_consultant_uid })

const deleteFeed = (id) => delV1(`feeds/${id}`)

const initFeedEdit = (id) => {
    const params = {}
    if (id) {
        params.building_id = id
    }
    return getV1(`blogs/new`, params )
}

const getRecommendation = (position, limit) => getV1(`recommendation`, {
    position,
    limit
})

const getBrand = (keyword) => getV1(`recommendation`, {
    position: 'brand_search',
    limit: 1,
    keyword
})

const getConsultantFeeds = (consultantId, page) => getV1('feeds', {
    consultant_id: consultantId,
    page,
    per: DEFAULT_PER
})

const likeFeed = (id, liked) => {
    if (liked) {
        return delV1(`feeds/${id}/like`)
    }
    return postV1(`feeds/${id}/like`)
}

const getFeedComments = (id, data) => getV1(`feeds/${id}/comments`, {
    per: DEFAULT_PER,
    ...data
})
const addFeedComments = (id, data) => postV1(`feeds/${id}/comments`, data)

const getPopup = () => getV1(`popup_buildings`)

const interestingEvent = (data) => {
    console.error(data)
    if (!isProd) return
    return postV1('interesting_events', data)
}

const startSession = ({ consultantId, sessionId, from }) => {
    if (consultantId) {
        return postV1('tim_sessions', { consultant_id: consultantId, from })
    }
    return getV1(`tim_sessions/${sessionId}`)
}

const endSession = (id) => delV1(`tim_sessions/${id}`)

const getSessions = (opt = { page: 1 }) => getV1('tim_sessions', opt)
const readTimMsg = (msgs) => postV1('tim_read_messages', {
    _json: msgs
})
const delTimMsg = (id) => delV1(`tim_sessions/${id}`)
const setTimTop = (id, params) => putV1(`tim_sessions/${id}`, params)

const getCaptchas = (mobile) => postV1('sms_captchas', { mobile })

const updateWxUserInfo = (data) => {
    console.error(data)
    try {
        const { rawData } = data
        const user_info = rawData ? JSON.parse(rawData) : {}
        console.error(user_info)
        if (!user_info.nickName || !user_info.nickName.trim()) {
            errorLog(`nickname_null:${JSON.stringify(data)}`)
        }
    } catch (err) {
        errorLog(`nickname_null:${err}`)
    }
    return putV1('wx_user_info', data)
}

const getLoanType = (building_id) => getV1('bank_clients/new', { building_id })
const bankClients = (data) => postV1('bank_clients', data)
const bankClientsMaxLoanAmount = (data) => postV1('bank_clients/max_loan_amount', data)
const getLuckyDrawData = () => getV1('activity_d/lottery_tips')

const getFootPrint = (params) => getV1('view_histories', params)
const getNoticeStatus = () => getV1('subscribed_notifications')
const setNoticeStatus = (params) => postV1('subscribed_notifications', params)

const setBlockStatus = (id, params) => putV1(`tim_sessions/${id}`, params)


export default {
    init: () => {
        return init()
    },

    getHomePage,
    getHotHouses,

    getUserNums,
    addUserNum,
    getUserResult,
    getResult,
    getRegResult,

    report,

    getUserInfo,
    getUserInfoByShareBy,
    updateUserInfo,
    viewTip,
    getCustomerServiceStaff,

    getZones,
    syncInfo,

    getUserPoints,
    share,
    getPointsStore,

    getComments,
    getCommentDetail,
    postComment,

    getChangeLog,

    verifyQualication,

    getLnDetail,

    getMyConsultant,
    editMyConsultant,
    updateConsultant,
    getConsultants,
    getConsultant,
    getConsultantHistory,

    getHouseNames,
    getConsultantViewers,
    getConsultantScore,
    likeConsultant,

    getWxArticles,

    getBuildings,
    getBuilding,
    getBuildingComments,
    getBuildingCommentDetail,
    getCommentsReply,
    newBuildingComment,
    postBuildingComment,
    getCommunityTopics,
    getCommunityTopicsDetail,
    getTopicsComments,
    postTopicsComment,
    likeComment,
    delLikedComment,

    getMyFavourite,
    addMyFavourite,
    delMyFavourite,
    addFollow,
    delFollow,

    getMsg,
    readAllMsg,
    getNewMsgLen,

    initFeedEdit,
    getRecommendation,
    createBlog,
    getFeeds,
    getFeed,
    likeFeed,
    deleteFeed,
    getFeedComments,
    addFeedComments,
    getConsultantFeeds,

    getPopup,

    interestingEvent,

    startSession,
    endSession,
    getSessions,
    readTimMsg,
    delTimMsg,
    setTimTop,

    getCaptchas,
    updateWxUserInfo,

    getLoanType,
    bankClients,
    bankClientsMaxLoanAmount,
    getLpdResult,
    getLrdResult,
    readAllTimMsg,
    readTimSession,
    getLuckyDrawData,
    getFootPrint,
    getNoticeStatus,
    setNoticeStatus,
    getBrand,

    setBlockStatus,
    getSmsCaptcha,
    logging_in
}
